// extracted by mini-css-extract-plugin
module.exports = {"partnersContainer":"Partners_partnersContainer__2CaBY","partnerImg":"Partners_partnerImg__N5T5Y","imgContainer":"Partners_imgContainer__3UVb6"};